import React from "react";
/// React router dom
import { Routes, Route, Outlet } from "react-router-dom";
/// Css
import "./index.css";
import "./Css/CustomCss.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";

/// Dashboard
import Home from "./components/Dashboard/Home";

import ScrollToTop from "./layouts/ScrollToTop";

import UserDetails from "./pages/UserDetails";

import Terms from "./pages/TermsConditon";
import PrivacyPolicy from "./pages/PrivacyPolicy";

import About from "./pages/About";
import { Search } from "lucide-react";

import Subjects from "./pages/Subjects";

import Dashboards from "./pages/DashBoard";

import SubSubjects from "./pages/SubSubjects";
import Subscriptions from "./pages/Subscriptions";
import Earnings from "./pages/Earnings";
import AboutForm from "./pages/AboutUsForm";
import MediaTabsPage from "./pages/Questions";
import Users from "./pages/UserManagement";
import Mentor from "./pages/Mentor";
import { components } from "react-select";
import ContactUs from "./pages/contactUS";

const Markup = () => {
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

  const allroutes = [
    /// Dashboard
    // { url: "", component: <Dashboards /> },
  { url: "", component: <Users /> },
    // { url: "job-posting", component: <JobPosting /> },

    { url: "user-details", component: <UserDetails /> },
    { url: "user-details/:id", component: <UserDetails /> },

    { url: "users", component: <Users /> },

    { url: "terms-condition", component: <Terms /> },

    { url: "dashboards", component: <Dashboards /> },

    { url: "privacy-policy", component: <PrivacyPolicy /> },
    {url:"contact-us",component:<ContactUs/>},
    { url: "about", component: <About /> },
    { url: "category", component: <Subjects /> },
    { url: "sub-category/:id", component: <SubSubjects /> },

    { url: "subscriptions", component: <Subscriptions /> },
    { url: "earnings", component: <Earnings /> },
    { url: "/admin/about-form", component: <AboutForm /> },
    { url: "/questions/:id", component: <MediaTabsPage /> },
    { url: "/mentor", component: <Mentor /> },

  ];

  return (
    <>
      <Routes>
        <Route element={<MainLayout />}>
          {allroutes.map((data, i) => (
            <Route
              key={i}
              exact
              path={`${data.url}`}
              element={data.component}
            />
          ))}
        </Route>
      </Routes>
      <ScrollToTop />
    </>
  );
};

function MainLayout() {
  //const { menuToggle, sidebariconHover } = useContext(ThemeContext);
  return (
    <>
      <div id="main-wrapper" className={`show`}>
        {/* <div id="main-wrapper" className={`show ${sidebariconHover ? "iconhover-toggle": ""} ${ menuToggle ? "menu-toggle" : ""}`}>   */}
        <Nav />
        <div
          className="content-body"
          style={{ minHeight: window.screen.height - 140 }}
        >
          <div className="container-fluid bdy">
            <Outlet />
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}
function FrontLayout() {
  return (
    <>
      <div className="overflow-unset">
        {/* <Layout /> */}
        <Outlet />
      </div>
    </>
  );
}

export default Markup;
